var map = {
	"./App.vue": [
		"3dfd"
	],
	"./components/Docs/ApprovalOfSettlementInstructions.vue": [
		"995c",
		"layout-components-Docs-ApprovalOfSettlementInstructions-vue"
	],
	"./components/Docs/DeliveryInstructions.vue": [
		"cf0f",
		"layout-components-Docs-DeliveryInstructions-vue"
	],
	"./components/Docs/HoldingCertificate.vue": [
		"219a",
		"layout-components-Docs-HoldingCertificate-vue"
	],
	"./components/Docs/ObligationTransfer.vue": [
		"f0f6",
		"layout-components-Docs-ObligationTransfer-vue"
	],
	"./components/Docs/PurchaseConfirmation.vue": [
		"4146",
		"layout-components-Docs-PurchaseConfirmation-vue"
	],
	"./components/Docs/SaleConfirmation.vue": [
		"df99",
		"layout-components-Docs-SaleConfirmation-vue"
	],
	"./components/Docs/SaleConfirmationToAston.vue": [
		"87ef",
		"layout-components-Docs-SaleConfirmationToAston-vue"
	],
	"./components/Docs/SaleDocuments.vue": [
		"4f3c",
		"layout-components-Docs-SaleDocuments-vue"
	],
	"./components/Docs/SettlementInstructions.vue": [
		"c0d2",
		"layout-components-Docs-SettlementInstructions-vue"
	],
	"./components/Docs/TransferOfOwnership.vue": [
		"71f0",
		"layout-components-Docs-TransferOfOwnership-vue"
	],
	"./components/Error/NotFound.vue": [
		"6199"
	],
	"./components/Loading/Loading.vue": [
		"4b5c",
		"layout-components-Loading-Loading-vue"
	],
	"./components/Login/ChangePassword.vue": [
		"526e",
		"layout-components-Login-ChangePassword-vue"
	],
	"./components/Login/ForgotPassword.vue": [
		"a5fb",
		"layout-components-Login-ForgotPassword-vue"
	],
	"./components/Login/Login.vue": [
		"de64",
		"layout-components-Login-Login-vue"
	],
	"./components/Login/ResetPassword.vue": [
		"ba4b4",
		"layout-components-Login-ResetPassword-vue"
	],
	"./components/Masters/AddBankCommodity.vue": [
		"a740",
		"layout-components-Masters-AddBankCommodity-vue"
	],
	"./components/Masters/BankCommodities.vue": [
		"f996",
		"layout-components-Masters-BankCommodities-vue"
	],
	"./components/Masters/Commodities.vue": [
		"83c7",
		"layout-components-Masters-Commodities-vue"
	],
	"./components/Masters/CommodityAdd.vue": [
		"8b46",
		"layout-components-Masters-CommodityAdd-vue"
	],
	"./components/Masters/UploadPrices.vue": [
		"d038",
		"layout-components-Masters-UploadPrices-vue"
	],
	"./components/Masters/User.vue": [
		"d8b8",
		"layout-components-Masters-User-vue"
	],
	"./components/Masters/Users.vue": [
		"34a9",
		"layout-components-Masters-User-vue",
		"layout-components-Masters-Users-vue"
	],
	"./components/Masters/Vendor.vue": [
		"6daa",
		"layout-components-Masters-Vendor-vue"
	],
	"./components/Masters/VendorCommodities.vue": [
		"3ead",
		"layout-components-Masters-VendorCommodities-vue"
	],
	"./components/Masters/VendorMaster.vue": [
		"f3ea",
		"layout-components-Masters-VendorMaster-vue"
	],
	"./components/Masters/Vendors.vue": [
		"979c",
		"layout-components-Masters-Vendor-vue",
		"layout-components-Masters-Vendors-vue"
	],
	"./components/Masters/VendorsCommodity.vue": [
		"1ff5",
		"layout-components-Masters-VendorsCommodity-vue"
	],
	"./components/Masters/commissions.vue": [
		"34f3",
		"layout-components-Masters-commissions-vue"
	],
	"./components/Requests/CompletedRequest.vue": [
		"ca0f",
		"layout-components-Requests-ViewBuyRequest-vue",
		"layout-components-Requests-CompletedRequest-vue~layout-components-Requests-Requests-vue~layout-compo~1fda5d20",
		"layout-components-Requests-CompletedRequest-vue"
	],
	"./components/Requests/MIS.vue": [
		"b416",
		"layout-components-Requests-MIS-vue"
	],
	"./components/Requests/Requests.vue": [
		"9aa5",
		"layout-components-Requests-ViewBuyRequest-vue",
		"layout-components-Requests-CompletedRequest-vue~layout-components-Requests-Requests-vue~layout-compo~1fda5d20",
		"layout-components-Requests-Requests-vue"
	],
	"./components/Requests/Sale.vue": [
		"17e0",
		"layout-components-Requests-Sale-vue"
	],
	"./components/Requests/SellRequests.vue": [
		"207a",
		"layout-components-Requests-ViewBuyRequest-vue",
		"layout-components-Requests-SellRequests-vue"
	],
	"./components/Requests/ViewBuyRequest.vue": [
		"f6be",
		"layout-components-Requests-ViewBuyRequest-vue"
	],
	"./components/Requests/buyRequests.vue": [
		"3ef7",
		"layout-components-Requests-CompletedRequest-vue~layout-components-Requests-Requests-vue~layout-compo~1fda5d20",
		"layout-components-Requests-buyRequests-vue"
	],
	"./components/common/Loading.vue": [
		"f453"
	],
	"./components/common/Modal.vue": [
		"11de"
	],
	"./components/dashboard/Home.vue": [
		"f958",
		"layout-components-dashboard-Home-vue"
	],
	"./layouts/auth.vue": [
		"3bb0",
		"layout-layouts-auth-vue"
	],
	"./layouts/default.vue": [
		"7b3d",
		"layout-layouts-default-vue"
	],
	"./layouts/delete.vue": [
		"3bfe",
		"layout-layouts-delete-vue"
	],
	"./layouts/error.vue": [
		"fba3",
		"layout-layouts-error-vue"
	],
	"./layouts/login.vue": [
		"33d1",
		"layout-layouts-login-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4adc";
module.exports = webpackAsyncContext;